import $ from "jquery";
import {
  INITIAL_CONFIGURATION_DETAIL,
  INITIAL_SYSTEM_OPTIONS,
} from "../../../constants/configurations";
import { DisplayMsg } from "../../../services/toastService";
import {
  setCurrentClientTnsName,
  setCurrentFacilityId,
} from "../../../store/reducers/SharedLayoutDataSlice";
import { FetchData } from "../../../utils/array";

export const loadConfigurationData = async (clientId, dispatch) => {
  try {
    const data = new FormData();
    data.append("seqNum", clientId);
    document.getElementById("loader").style.display = "block";

    const response = await FetchData(
      `Entity/${clientId}/configurations`,
      "support"
    );

    if (response && !response?.succeeded) {
      return response;
      // throw new Error("Invalid response");
    }

    // Initialize result object to return values
    const result = {
      configureData: [],
      systemOptionData: [],
      featureOptionData: [],
      entityData: {},
      triggerInfo: {
        entity: true,
        system: true,
        feature: true,
      },
      boxesUpdate: {},
      tnsName: "",
      succeeded: true,
    };

    const configurationData = response.data;

    // Handle TNS Name
    if (configurationData.TNSName) {
      dispatch(setCurrentClientTnsName(configurationData.tnsName));
    }

    // Entity Data
    if (configurationData.entityData != null) {
      dispatch(setCurrentFacilityId(configurationData.entityData.facilityId));
      const practiceData = configurationData.entityData;
      $("#ConfigurationSetupDetail #practiceSetupName").val(
        practiceData.autoVitalSigns
      );
      sessionStorage.isptflow = practiceData.isTeleClinic;

      result.configureData = INITIAL_CONFIGURATION_DETAIL.map((entry) => {
        const isVisible = practiceData[entry.flag];
        if (entry.title === "Tele Visit Payment Amount") {
          result.boxesUpdate.Visit = isVisible;
        }
        return {
          ...entry,
          visible: isVisible,
        };
      });

      result.triggerInfo.entity = false;
    }

    // System Options
    if (configurationData.systemOptions?.length > 0) {
      const SytemOPtionsData = configurationData.systemOptions[0];

      result.systemOptionData = INITIAL_SYSTEM_OPTIONS.map((entry) => {
        const isVisible = SytemOPtionsData[entry.flag];
        if (entry.title === "Elig Future Days") {
          result.boxesUpdate.Future = isVisible;
        }
        return {
          ...entry,
          visible: isVisible,
        };
      });

      result.triggerInfo.system = false;
    }

    // Advanced Features
    if (configurationData.advanceFeaturesData?.length > 0) {
      const featureData = configurationData.advanceFeaturesData;

      result.featureOptionData = featureData
        .filter((feature) => feature.title && feature.helpText)
        .map((feature) => ({
          adv_option_seq_num: "Advanced_Feature",
          advancedSeqNum: feature.advanceOptionsId,
          DESCRIPTION: feature.description,
          ENTITY_SEQ_NUM: feature.entityId, // sessionStorage["ENTITY_SEQ_NUM"]
          HELP_TEXT: feature.helpText,
          flag: feature.advanceOptionsId,
          title: feature.title,
          visible: feature.visible,
        }));
      result.triggerInfo.feature = false;
    }
    result.tnsName = configurationData.tnsName;
    result.entityData = configurationData.entityData;

    document.getElementById("loader").style.display = "none";
    return result;
  } catch (e) {
    document.getElementById("loader").style.display = "none";
    DisplayMsg("2", "Unable to Process the Request");
    return null;
  }
};
